<dt :class="{'kl-description-list__term': true, 'kl-description-list__term--collapse': modCollapse }">
    {{label}}
</dt>
<dd :class="{'kl-description-list__description': true, 'kl-description-list__description--collapse': modCollapse }">
    <slot></slot>
</dd>
